import { FCWithChildren } from '@types';
import React from 'react';

import { IInvitee, IReceivedInvitation } from 'sdk-apogee';
import { Invitee } from '@components';
import { InviteeVariant } from '@components/Invitee/Invitee';

import { ActionTypes } from '../../SharedList';

type InviteProps = {
  title: string;
  list: IInvitee[] | IReceivedInvitation[];
  variant: InviteeVariant;
  dispatch: (action: ActionTypes) => void;
};

const Invite: FCWithChildren<InviteProps> = ({ title, list, variant, dispatch }) => (
  <section className="w-full">
    <h2 className="mb-2 text-black">{title}</h2>
    {list.map((invitee, idx) => (
      <Invitee
        key={`${idx}-${invitee.accountEmail}`}
        invitee={invitee}
        variant={variant}
        dispatch={dispatch}
      />
    ))}
  </section>
);

export default Invite;
